/// <amd-module name="Tfs/Frame/Components/Profile/Util/MeControlConstants" />

export namespace MeControlConstants {
    export const LoadScriptScenario = "LoadMeControlScriptScenario";
    export const Area = "MeControl";
    export const LoadScriptFeature = "LoadMeControlScript";
    export const LoadScriptFailAction = "Load me control script failure";
    export const LoadComponentFeature = "LoadMeControlComponent";
    export const LoadComponentFailAction = "Load me control component failure";
}
